import { CONFIG_DISENO_GET_SUCCESS, CONFIG_DISENO_GET_FAILURE } from "../actions/configuracion_diseno/types";

const initialState = {
  is_vertical: 0,
  loaded: false,
};

const configuracionDisenoReducer = (state = initialState, action) => {
  switch (action.type) {
    case CONFIG_DISENO_GET_SUCCESS:
      return { ...state, is_vertical: action.payload?.is_vertical ?? 0, loaded: true };
    case CONFIG_DISENO_GET_FAILURE:
      return { ...state, loaded: true };
    default:
      return state;
  }
};

export default configuracionDisenoReducer;
